import { TrackedJob, TrackedJobStatus } from "~frontend/__generated__/graphql";

export function jobInProgress(job: Pick<TrackedJob, "status">): boolean {
  return (
    job.status === TrackedJobStatus.Created ||
    job.status === TrackedJobStatus.Queued ||
    job.status === TrackedJobStatus.Running
  );
}

export function jobFailed(job: Pick<TrackedJob, "status" | "errorMessage">): {
  failed: boolean;
  errorMessage: string;
} {
  if (job.status === TrackedJobStatus.Failed) {
    return { failed: true, errorMessage: job.errorMessage || "Unknown error" };
  }

  if (
    job.status === TrackedJobStatus.Stalled ||
    job.status === TrackedJobStatus.Aborted
  ) {
    return { failed: true, errorMessage: "Job stalled, please re-try" };
  }

  if (job.status === TrackedJobStatus.Canceled) {
    return { failed: true, errorMessage: "Job canceled, please re-try" };
  }

  return { failed: false, errorMessage: "" };
}
